import { Component, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  menuOpen = false;
  currentSlide = 0;
  currentProductSlide = 0;
  currentVideoSlide = 0;
  timers: any[] = [];

  // Updated with Verified Stable Image Links
  products = [
    { name: 'Makhana', img: 'assets/images/makhana_ne.jpg', description: 'Premium healthy fox nuts from India.' },
    { name: 'Tea', img: 'assets/images/tea.jpg', description: 'Fresh and aromatic Indian tea leaves.' },
    { name: 'Coffee', img: 'assets/images/coffee.webp', description: 'Rich taste premium coffee beans.' },
    { name: 'Turmeric', img: 'assets/images/haldi.webp', description: 'Pure natural turmeric powder.' },
    { name: 'Cumin Seeds', img: 'assets/images/cumin.png', description: 'Best quality Indian cumin seeds.' },
    // { name: 'Black Pepper', image: 'pepper.jpg', description: 'Strong aroma premium pepper.' },
    { name: 'Ginger', img: 'assets/images/ginger.webp', description: 'Pure natural ginger powder' },
    { name: 'Ashwagandha', img: 'assets/images/ashwagandha.jpg', description: 'Natural wellness herb product.' },
    { name: 'Moringa Powder', img: 'assets/images/moringa.webp', description: 'Healthy superfood powder.' },
    { name: 'Red Chilli', img: 'assets/images/redchilli.webp', description: 'Pure red chilli turmeric powder.' },
    { name: 'Cinnamon', img: 'assets/images/cinnamon.jpg', description: 'Fresh aromatic cinnamon sticks.' }
  ];

  sideVideos = [
    { title: 'Our Corporate Mission' },
    { title: 'Organic Farm Benefits' },
    { title: 'Global Export Process' }
  ];
  toggleMenu(){
    this.menuOpen = !this.menuOpen;
  }
  ngOnInit(){

    setInterval(() => {
  
      const cardWidth = window.innerWidth <= 768 ? 240 : 320;
  
      this.currentSlide += cardWidth;
  
      const maxScroll =
        (this.products.length * cardWidth) - window.innerWidth;
  
      if(this.currentSlide > maxScroll){
        this.currentSlide = 0;
      }
  
    }, 2500);
  
  }
  ngOnDestroy() { this.timers.forEach(t => clearInterval(t)); }
}